import { createContext, useState } from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

export const CalendarContext = createContext();

const CalendarProvider = ({ children }) => {
  const [monthIndex, setMonthIndex] = useState(dayjs().month());
  const [yearIndex, setYearIndex] = useState(dayjs().year());

  return (
    <CalendarContext.Provider
      value={{
        monthIndex,
        yearIndex,
        setMonthIndex,
        setYearIndex
      }}
    >
      {children}
    </CalendarContext.Provider>
  );
};

CalendarProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
    .isRequired
};

CalendarProvider.defaultProps = {};

export default CalendarProvider;
